export const BASE_RESOLUTIONS: ExecutionContainerOption[] = [
    { name: "Default Resolution", value: "default_resolution" },
    { name: "640x480", value: "640x480" },
    { name: "800x600", value: "800x600" },
    { name: "1024x768", value: "1024x768" },
    { name: "1280x720", value: "1280x720" },
    { name: "1280x800", value: "1280x800" },
    { name: "1366x768", value: "1366x768" },
    { name: "1440x900", value: "1440x900" },
    { name: "1600x900", value: "1600x900" },
    { name: "1680x1050", value: "1680x1050" },
    { name: "1920x1080", value: "1920x1080" },
    { name: "1920x1200", value: "1920x1200" }
]